module.exports = __webpack_public_path__ + "img/ignis-gls-plus-blanco-pop.386549b5.png";